import LinkWrapper from "../LinkWrapper";
import FaChevronRight from "../SVG/Fontawesome/FaChevronRight";

interface ITextBanner {
  className?: string;
  text: string | JSX.Element;
  url?: string;
  chevron?: boolean;
}

const TextBanner = (props: ITextBanner) => {
  return <div className={`bg-gradient-to-r from-[#d8b268] via-[#ffe695] to-[#d8b268] w-full flex items-center justify-center p-4 ${props.className ?? ""}`}>
    <div className="font-semibold text-base lg:text:lg sm:text-2xl my-0 dark:text-black">
      {
        props.url
          ? <LinkWrapper className="font-bold no-underline hover:underline dark:text-black" href={props.url}>
            {props.text}
            {props.chevron && <FaChevronRight className="animate-bounceHorizontal" />}
          </LinkWrapper>
          : props.text
      }
    </div>
  </div>
}

export default TextBanner;